import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import TenantActions from '@Actions/tenantActions';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import {
  Select, Table, Popconfirm, notification, Button,
} from 'antd';
import {
  CheckOutlined, PlusCircleFilled, DeleteOutlined, SaveOutlined,
} from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const UnicommerceMapLocations = ({
  user, getTenants, getTenantsLoading, tenants, verifyLocationLoading, verifyLocation,
  connectTenantToLocation, connectTenantToLocationLoading, setStep,
}) => {
  const [tenantData, setTenantData] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState('');

  useEffect(() => {
    getTenants(1, '', true, user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    if (!tenantData) {
      const tenantsData = tenants?.data?.filter((item) => item?.unicommerce_facility_code)?.map((tenant) => ({ ...tenant, location: tenant?.unicommerce_facility_code, key: uuidv4() }));
      setTenantData(tenantsData);
    }
  }, [tenants]);

  const updateTableValue = (key, value, label) => {
    const data = tenantData.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setTenantData(data);
  };

  const getSelectedTenant = (record) => tenantData?.filter((item) => item?.tenant_id !== record?.tenant_id).map((tenant) => tenant.tenant_id);

  const getDataSource = (data) => (data ? JSON.parse(JSON.stringify(data)) : []);

  const addNewRow = () => {
    if (tenantData?.length) {
      setTenantData([...tenantData, { key: uuidv4() }]);
    } else {
      setTenantData([{}]);
    }
  };

  const removeRow = (key) => {
    if (tenantData?.length > 1) {
      const newTenantData = getDataSource(tenantData)?.filter((tenant) => tenant.key !== key);
      setTenantData(newTenantData);
    } else {
      setTenantData([{}]);
    }
  };

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (tenantData?.filter((tenant) => !tenant?.unicommerce_facility_codes)?.length === 0) {
      const payload = tenantData?.filter((tenant) => tenant?.unicommerce_facility_codes)?.map((tenant) => ({
        tenant_id: tenant?.tenant_id,
        facility_code: tenant?.location,
      }));
      connectTenantToLocation(payload, () => {
        setStep(3);
      });
    } else {
      notification.error({
        message: 'Please verify location for all the tenants you have added',
        placement: 'top',
        duration: 4,
      });
    }
  };

  const columns = [
    {
      title: 'Business Unit Name',
      render: (record) => (
        <div>
          <PRZSelect
            value={record?.tenant_id}
            dropdownAlign={{ offset: [-4, 4] }}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            showSearch
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.key, value, 'tenant_id');
              setSearchKeyword('');
            }}
            placeholder="Select Business Unit"
            onSearch={(value) => {
              setSearchKeyword(value);
            }}
          >
            {tenants?.data
              ?.filter((item) => !getSelectedTenant(record)?.includes(item?.tenant_id))
              ?.filter((item) => (searchKeyword ? item?.tenant_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))
              .map(
                (item) => <Option key={item?.tenant_id} value={item?.tenant_id}>{item?.tenant_name}</Option>,
              )}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: 'Facility Code',
      render: (record) => (
        <input
          onChange={(e) => {
            updateTableValue(record?.key, e.target.value, 'location');
          }}
          value={record?.location || ''}
          className={`${(formSubmitted && !record?.location) && 'error-outlined' } orgFormInput`}
        />
      ),
    },
    {
      title: '',
      render: (record) => (
        <div>
          {!record?.unicommerce_facility_codes?.length ? (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              <div
                onClick={() => {
                  verifyLocation(user?.tenant_info?.org_id, record.location, () => {
                    const data = tenantData.map((tenant) => {
                      if (tenant.tenant_id === record?.tenant_id) {
                        // eslint-disable-next-line no-param-reassign
                        tenant.unicommerce_facility_codes = [record.location];
                        return tenant;
                      }

                      return tenant;
                    });

                    setTenantData(data);
                  });
                }}
              >
                <div className="roundIconButton">
                  <SaveOutlined />
                </div>
              </div>
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this line?"
                onConfirm={() => removeRow(record?.key)}
                okText="Yes"
                cancelText="No"
              >
                <div className="deleteButton">
                  {' '}
                  <DeleteOutlined />
                  {' '}
                </div>
              </Popconfirm>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              {' '}
              <div className="verify-tick roundIconButton">
                {' '}
                <CheckOutlined />
                {' '}
              </div>
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this line?"
                onConfirm={() => removeRow(record?.key)}
                okText="Yes"
                cancelText="No"
              >
                <div className="deleteButton" style={{ color: 'red' }}>
                  {' '}
                  <DeleteOutlined />
                  {' '}
                </div>
              </Popconfirm>

            </div>

          ) }

        </div>
      ),

    },

  ];

  return (
    <Fragment>
      {getTenantsLoading
        ? (
          <div className="unicommerce-integration__loader__wrapper">
            <div className="loadingBlock unicommerce-integration__loader__line1" />
            <div className="loadingBlock unicommerce-integration__loader__line2" />
            <div className="loadingBlock unicommerce-integration__loader__line3" />
          </div>
        )
        : (
          <div className="integration-step__wrapper">
            <div className="ant-row">
              <div className="ant-col-md-18">
                <Table
                  columns={columns}
                  loading={verifyLocationLoading}
                  dataSource={getDataSource(tenantData) || []}
                  size="small"
                  pagination={false}
                />
              </div>
            </div>
            <div className="new-row-button" onClick={() => addNewRow()} style={{ width: '110px !important' }}>
              <span className="new-row-button__icon"><PlusCircleFilled /></span>
              <div>New Item</div>
            </div>
            <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
              <Button
                type="primary"
                ghost
                onClick={() => setStep(1)}
                loading={connectTenantToLocationLoading}
                disabled={connectTenantToLocationLoading}
              >
                Back
              </Button>
              &nbsp;&nbsp;
              <Button
                type="primary"
                onClick={() => handleSubmit()}
                loading={connectTenantToLocationLoading}
                disabled={connectTenantToLocationLoading}
              >
                Save
              </Button>
            </div>
          </div>
        )}
    </Fragment>
  );
};
const mapStateToProps = ({ /* Import Reducers here */ UserReducers, UnicommerceIntegrationReducers, TenantReducers }) => ({
  user: UserReducers.user,
  connectToUnicommerceLoading: UnicommerceIntegrationReducers.connectToUnicommerceLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  tenants: TenantReducers.tenants,
  verifyLocationLoading: UnicommerceIntegrationReducers.verifyLocationLoading,
  connectTenantToLocationLoading: UnicommerceIntegrationReducers.connectTenantToLocationLoading,

});

const mapDispatchToProps = (/* Import actions here */ dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  verifyLocation: (orgId, facilityCode, callback) => dispatch(
    UnicommerceIntegrationActions.verifyLocation(orgId, facilityCode, callback),
  ),
  getUnicommerceConnections: (orgId, callback) => dispatch(UnicommerceIntegrationActions.getUnicommerceConnections(orgId, callback)),
  connectTenantToLocation: (payload, callback) => dispatch(UnicommerceIntegrationActions.connectTenantToLocation(payload, callback)),
});

UnicommerceMapLocations.propTypes = {
  user: PropTypes.any,
  getTenants: PropTypes.func,
  verifyLocationLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  verifyLocation: PropTypes.any,
  connectTenantToLocation: PropTypes.func,
  connectTenantToLocationLoading: PropTypes.bool,
  setStep: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnicommerceMapLocations));
